module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product25-cc1da7d4391ca5d7a3c3cd7c37a5c1f2.jpg";